import { Client_Config_Preview } from "./Client_Config.preview";
import { Client_Config_Localdev } from "./Client_Config.localdev";
import { Client_Config_Production } from "./Client_Config.production";
import { Client_Environment_Config } from "./Client_Environment_Config_Type";

export const Environments: {[index: string]: Client_Environment_Config} = {
	localdev: Client_Config_Localdev,
    preview: Client_Config_Preview,
    production: Client_Config_Production,
}

let env: Client_Environment_Config

export function set_environment(env_name: string) {
    console.log('setting environment to ', env_name)
    env = Environments[env_name]
}

export function get_environment() {
    if (!env) {
        throw new Error("get_environment called before an environment was set")
    }
    return env
}